import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Card           from '@material-ui/core/Card'
import CardActions    from '@material-ui/core/CardActions'
import Grid           from '@material-ui/core/Grid'
import Typography     from '@material-ui/core/Typography/Typography'
import { FieldArray } from 'formik'

import { FormikFormChunkProps }    from '../../../types'
import {
  ActionButton,
  EnhancedTextField,
  InlineError,
}                                  from '../../atoms'
import withDialogControls, {
  InjectedDialogControlProps,
}                                  from '../../hocs/withDialogControls'
import { ContactCard }             from '../../molecules'
import AddContactForm              from '../ContactAddForm'
import mapFormikToMuiProps         from '../form-utils/map-formik-to-mui-props'
import { CreateCompanyFormValues } from '../schemas'

interface CompanyChunkProps {
  mode: 'edit' | 'create'
}

type Props =
  CompanyChunkProps
  & FormikFormChunkProps<CreateCompanyFormValues>

const CompanyChunk = (props: Props & InjectedDialogControlProps) => {
  const propMapper = mapFormikToMuiProps(props)

  const { isOpen, open, close, mode } = props

  return (
    <Grid container spacing={24}>

      {/*
       TODO:
       this chunk serves as both create and edit chunk and because
       the only difference between the two is that the edit form
       should not display the email we simply don't when it is rendered
       as the edit form
       */}

      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          {...propMapper('name')}
        />
      </Grid>
      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          {...propMapper('cif')}
        />
      </Grid>
      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          {...propMapper('address')}
        />
      </Grid>
      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          {...propMapper('phone')}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant={'title'}>
          <FormattedMessage id={'generic.primaryContactInfo'} />
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          {...propMapper('contactName')}
        />
      </Grid>

      {mode === 'create' && (
        <Grid item xs={12}>
          <EnhancedTextField
            fullWidth
            {...propMapper('email')}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          {...propMapper('mobile')}
        />
      </Grid>

      <FieldArray
        name={'contacts'}
        render={({
          push,
          remove,
          form:
            { values },
        }) => (
          <>
            <Grid item xs={12}>
              <Grid
                container
                justify={'space-between'}
                alignItems={'center'}
              >
                {isOpen && (
                  <AddContactForm
                    close={close}
                    isOpen={isOpen}
                    onSubmit={values => {
                      close()
                      push(values)
                    }}
                  />
                )}
                <Typography>
                  <FormattedMessage id={'generic.addAnotherContact'} />
                </Typography>
                <ActionButton
                  onClick={open}
                  actionType={'add'}
                  color={'primary'}
                />
              </Grid>
            </Grid>
            {values.contacts && values.contacts.map((contact: any, i: any) => (
              <Grid item xs={12} key={i}>
                <Card>
                  <ContactCard {...contact} />
                  <CardActions>
                    <ActionButton
                      actionType={'remove'}
                      onClick={() => remove(i)}
                      color={'secondary'}
                    />
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </>
        )}
      />
      {
        props.errors.contacts
        && props.touched.contacts
        && (
          <Grid item xs={12}>
            <InlineError i18nErrorId={'validation.' + props.errors.contacts} />
          </Grid>
        )}
    </Grid>
  )
}

export default withDialogControls(CompanyChunk)



// WEBPACK FOOTER //
// ./src/components/forms/chunks/CompanyChunk.tsx